/* Puppy Jo - curated-first collection landing (2026-10-14).
   Ad links land on /collections/<x>?first=<product-handle>[&variant=<id>].
   The matching product card is moved to the first grid slot; if it is not on this
   page, its card is fetched in one request through storefront search by
   product id (same card markup) and pinned. The grid stays hidden until then
   (1.5s failsafe in the loader section). With
   &variant= the card image and link switch to that variant. Re-pins after the
   grid re-renders (sort/filter). Modeled on the BuildMyPOD curated-first script
   seen on mastermind stores; written fresh for this theme. */
(function () {
  var cfgEl = document.querySelector('script[data-pj-curated-first]');
  if (!cfgEl) return;
  var PARAM = cfgEl.getAttribute('data-param') || 'first';
  var SWAP = cfgEl.getAttribute('data-swap-image') !== 'false';
    var qs = new URLSearchParams(window.location.search);
  var raw = qs.get(PARAM); if (!raw) return;
  var handle = raw.split('?')[0].split('#')[0].split('/').pop().toLowerCase();
  var variant = (qs.get('variant') || '').replace(/[^0-9]/g, '') || null;
  if (!handle) return;
  var state = { pinning: false, failed: false, inflight: false, raf: 0, variantImg: null };
  function reveal() { document.documentElement.classList.remove('pj-cf-pending'); }

  function grid() { var l = document.querySelector('results-list'); return l ? (l.querySelector('[ref="grid"]') || l.querySelector('.product-grid')) : null; }
  function cards(g) { return Array.prototype.slice.call(g.querySelectorAll(':scope > [ref="cards[]"]')); }
  function linkMatches(href) {
    if (!href) return false; var m = '/products/' + handle; var i = href.toLowerCase().indexOf(m);
    if (i === -1) return false; var c = href.charAt(i + m.length); return c === '' || c === '?' || c === '#' || c === '/';
  }
  function cardMatches(card) { var ls = card.querySelectorAll('a[href*="/products/"]'); for (var i = 0; i < ls.length; i++) if (linkMatches(ls[i].getAttribute('href'))) return true; return false; }
  function findCard(g, exclude) { var cs = cards(g); for (var i = 0; i < cs.length; i++) if (cs[i] !== exclude && cardMatches(cs[i])) return cs[i]; return null; }
  function toFront(g, card) { var first = g.querySelector(':scope > [ref="cards[]"]'); if (first && first !== card) g.insertBefore(card, first); card.setAttribute('data-pj-pinned', '1'); }

  function withVariant(href) { try { var u = new URL(href, location.origin); u.searchParams.set('variant', variant); return u.pathname + u.search + u.hash; } catch (e) { return href; } }
  function applyVariant(card) {
    if (!variant) return;
    var ls = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < ls.length; i++) if (linkMatches(ls[i].getAttribute('href'))) ls[i].setAttribute('href', withVariant(ls[i].getAttribute('href')));
    if (!SWAP) return;
    if (state.variantImg) { swapImage(card, state.variantImg); return; }
    fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return; var v = null;
      for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === variant) { v = p.variants[i]; break; }
      if (v && v.featured_image && v.featured_image.src) { state.variantImg = v.featured_image.src; swapImage(card, state.variantImg); }
    }).catch(function () {});
  }
  function sized(src, w) { try { var u = new URL(src, location.origin); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return src; } }
  function swapImage(card, src) {
    if (card.getAttribute('data-pj-swapped') === src) return;
    var img = card.querySelector('img'); if (!img) return;
    img.setAttribute('src', sized(src, 640));
    img.setAttribute('srcset', [320, 480, 640, 960].map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', '));
    img.removeAttribute('data-src'); card.setAttribute('data-pj-swapped', src);
  }

  function cleanHref(href) {
    try { var u = new URL(href, location.origin); ['_pos', '_sid', '_ss', '_psq', '_fid'].forEach(function (k) { u.searchParams.delete(k); });
      return u.pathname + (u.search === '?' ? '' : u.search) + u.hash; } catch (e) { return href; }
  }
  function fetchCard() {
    /* Product not on this page: fetch its card via storefront search by product id
       (one request; the search grid uses the same card markup), then pin it. */
    if (state.failed || state.inflight) return; state.inflight = true;
    var done = function () { state.inflight = false; reveal(); };
    fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) { state.failed = true; done(); return; }
      return fetch('/search?type=product&q=' + encodeURIComponent('id:' + p.id)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var found = null, cs = doc.querySelectorAll('[ref="cards[]"]');
        for (var i = 0; i < cs.length; i++) if (cardMatches(cs[i])) { found = cs[i]; break; }
        var live = grid();
        if (!found || !live) { state.failed = true; done(); return; }
        var node = document.importNode(found, true);
        node.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.setAttribute('href', cleanHref(a.getAttribute('href'))); });
        node.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.setAttribute('loading', 'eager'); });
        node.setAttribute('data-fetched', '1');
        state.pinning = true; try { toFront(live, node); applyVariant(node); } finally { state.pinning = false; }
        done();
      });
    }).catch(function () { state.failed = true; done(); });
  }

  function pin() {
    var g = grid(); if (!g || state.pinning) return;
    state.pinning = true;
    try {
      var first = g.querySelector(':scope > [ref="cards[]"]');
      if (first && cardMatches(first)) { var dup = findCard(g, first); if (dup) dup.remove(); applyVariant(first); reveal(); return; }
      var card = findCard(g, null);
      if (card) { toFront(g, card); applyVariant(card); reveal(); return; }
    } finally { state.pinning = false; }
    fetchCard();
  }

  function observe() {
    var l = document.querySelector('results-list'); if (!l || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (state.pinning || state.raf) return;
      state.raf = requestAnimationFrame(function () { state.raf = 0; pin(); });
    }).observe(l, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { pin(); observe(); });
  else { pin(); observe(); }
})();
